import { useEffect } from 'react';
import { setNotificationCallback } from '../api';
import { useNotification } from '../contexts/NotificationContext';

export const useApiNotifications = () => {
  const { showNotification } = useNotification();

  useEffect(() => {
    // Set the notification callback for the API interceptor
    setNotificationCallback(showNotification);

    // Cleanup function
    return () => {
      setNotificationCallback(null);
    };
  }, [showNotification]);
}; 